import { render, staticRenderFns } from "./userAgreement.vue?vue&type=template&id=e8d16b44"
import script from "./userAgreement.vue?vue&type=script&lang=js"
export * from "./userAgreement.vue?vue&type=script&lang=js"
import style0 from "./userAgreement.vue?vue&type=style&index=0&id=e8d16b44&prod&lang=less&scpoed=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports